import {
  FaChartLine,
  FaGlobe,
  FaHandshake,
  FaLightbulb,
  FaScaleBalanced,
  FaSeedling,
  FaShieldHalved,
} from 'react-icons/fa6'

export const leadershipHero = {
  eyebrow: 'Leadership & Management',
  titleLine1: 'Leading With',
  titleAccent: 'Experience Building',
  titleLine2: 'With Vision',
  description:
    'At Torbit Metals Private Limited, our leadership team brings together expertise in finance, international trade, procurement, compliance, operations, and organizational management. Their collective experience enables the company to build strong business relationships, ensure operational excellence, and create sustainable growth opportunities.',
  primaryCta: { label: 'Meet Our Leaders', to: '#leadership-team' },
  secondaryCta: { label: 'Contact Us', to: '/contact#inquiry-form' },
}

export const leadershipTeamSection = {
  label: 'Leadership Team',
  titleLine1: 'Meet The',
  titleAccent: 'Leadership Team',
  content:
    'Our leadership team is committed to building a globally respected organization through professionalism, transparency, innovation, and long-term business relationships. Their diverse expertise provides a strong foundation for strategic growth and operational excellence.',
}

export const leadershipDirectors = [
  {
    id: 'priyanka-soni',
    name: 'Priyanka Soni',
    displayName: 'PRIYANKA SONI',
    designation: 'Director',
    experienceLabel: 'Finance, Compliance & International Trade',
    paragraphs: [
      'A Chartered Accountant and Business Consultant at Torbit Metals Private Limited since 2021, with extensive experience in financial management, regulatory compliance, and structuring international trade operations.',
      'She actively contributes to building a strong financial foundation for the company by ensuring effective financial planning, compliance adherence, risk management, and strategic decision-making.',
    ],
    expertise: [
      'Financial Management',
      'Regulatory Compliance',
      'International Trade Operations',
      'Strategic Planning',
      'Business Consulting',
      'Risk Management',
      'Corporate Governance',
    ],
    imageAlt: 'Priyanka Soni — Director, Torbit Metals Private Limited',
  },
]

export const leadershipPhilosophy = {
  label: 'Leadership Philosophy',
  titleLine1: 'Our',
  titleAccent: 'Leadership',
  titleLine2: 'Philosophy',
  paragraphs: [
    'Our leadership philosophy is built on integrity, accountability, innovation, and long-term value creation. We believe that sustainable success comes from transparent business practices, strong partnerships, and a commitment to continuous improvement.',
    'Through strategic thinking and responsible decision-making, we strive to create lasting value for clients, suppliers, employees, and stakeholders across global markets.',
  ],
  values: [
    { title: 'Integrity & Transparency', icon: FaShieldHalved },
    { title: 'Accountability', icon: FaScaleBalanced },
    { title: 'Innovation & Growth', icon: FaLightbulb },
    { title: 'Long-term Value Creation', icon: FaChartLine },
    { title: 'Strategic Partnerships', icon: FaHandshake },
  ],
}

export const leadershipExpertiseSection = {
  label: 'Core Leadership Expertise',
  titleLine1: 'Expertise That',
  titleAccent: 'Drives Excellence',
}

export const leadershipExpertise = [
  { title: 'Financial Leadership', icon: 'financial' },
  { title: 'Strategic Procurement', icon: 'procurement' },
  { title: 'International Trade', icon: 'trade' },
  { title: 'Business Operations', icon: 'operations' },
  { title: 'Compliance Management', icon: 'compliance' },
  { title: 'Supply Chain Excellence', icon: 'supplyChain' },
  { title: 'Human Resource Development', icon: 'humanResource' },
  { title: 'Vendor Relationship Management', icon: 'vendor' },
]

export const leadershipVision = {
  label: 'Our Vision & Commitment',
  titleLine1: 'Our Vision &',
  titleAccent: 'Commitment',
  paragraphs: [
    'We are committed to building a globally recognized and trusted organization known for professionalism, reliability, operational excellence, and sustainable business growth.',
    'By strengthening strategic partnerships, expanding our international network, and continuously improving our capabilities, we aim to deliver long-term value to all stakeholders.',
  ],
  pillars: [
    { title: 'Global Presence', icon: FaGlobe },
    { title: 'Strong Partnerships', icon: FaHandshake },
    { title: 'Sustainable Growth', icon: FaSeedling },
  ],
}

export const leadershipCta = {
  title: 'Partner With Experienced Industry Leaders',
  description:
    'Connect with our leadership team to explore strategic partnerships, sourcing opportunities, and long-term business collaborations.',
  primaryCta: { label: 'Contact Leadership', to: '/contact#inquiry-form' },
  secondaryCta: { label: 'Request Consultation', to: '/contact#inquiry-form' },
}
